//-----------------------------------------------------------------------
// <copyright file="app.component.ts" company="LGT India">
//     Author: vanaraj
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//-----------------------------------------------------------------------
import { CookieService } from "ngx-cookie-service";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { AuthService } from "./services/auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UrlServices } from "./services/url.service";
import { environment } from "../environments/environment.onprem";
import { MsalService } from "@azure/msal-angular";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    // Define animations here
    trigger("myAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms", style({ opacity: 1 })),
      ]),
      transition(":leave", [animate("500ms", style({ opacity: 0 }))]),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  transactionData: any[] = [];
  accessToken: string | null = null;
  title = "LGT india";
  loginDisplay = false;
  durationInSeconds: number = 5;
  loading = false;
  private readonly _destroying$ = new Subject<void>();
  pageEvent = { pageIndex: 0, pageSize: 10, length: 100 };
  rightArrow: string;
  leftArrow: string;
  searchIcon: string;
  isIframe = false;
  userEmail: string = "";
  queryCode: string = "";
  private redirectionUrl = environment.envVar.redirectionUrl;

  private tokenExpirationTimer: any;
  constructor(
    private authService: MsalService,
    private snackBar: MatSnackBar,
    public auth: AuthService,
    private route: ActivatedRoute,
    private urlService: UrlServices
  ) {
    this.rightArrow = "/assets/icons/rightarrow.svg";
    this.leftArrow = "/assets/icons/leftarrow.svg";
    this.searchIcon = "/assets/icons/SearchIcon.svg";
  }
  selectedTabIndex: number = 0; // Set the default index

  //tabselect
  onSelectTab(index: number): void {
    this.selectedTabIndex = index;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((fragment) => {
      if (fragment) {
        const params = new URLSearchParams(fragment);
        const code = params.get("code");
        if (code) {
          this.queryCode = code;
        }
      }
    });
  }

  async login() {
    const code_verifier = this.generateCodeVerifier();
    sessionStorage.setItem("code_verifier", code_verifier);
    const code_challenge = await this.generateCodeChallenge(code_verifier);
    const url = `${this.urlService.url}
    client_id=${this.urlService.client}
    &response_type=code
    &redirect_uri=${this.redirectionUrl}/dashboard
    &response_mode=query
    &scope=openid profile offline_access
    &state=${this.generateCodeVerifier()}
    &code_challenge=${code_challenge}
    &code_challenge_method=S256`;
    window.location.href = url;
  }

  generateCodeVerifier(): string {
    const array = new Uint32Array(28);
    window.crypto.getRandomValues(array);

    // Convert the string to a Uint8Array using TextEncoder
    const encoder = new TextEncoder();
    const uint8Array = encoder.encode(
      String.fromCharCode.apply(null, Array.from(array))
    );

    // Use btoa on the Uint8Array
    const base64Encoded = btoa(
      String.fromCharCode.apply(null, Array.from(uint8Array))
    );

    // Replace characters as needed
    const sanitizedBase64 = base64Encoded
      .replace(/=/g, "")
      .replace(/\+/g, "-")
      .replace(/\//g, "_");

    return sanitizedBase64;
  }

  // Function to generate code_challenge from code_verifier
  async generateCodeChallenge(codeVerifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return btoa(
      String.fromCharCode.apply(null, Array.from(new Uint8Array(hashBuffer)))
    )
      .replace(/=/g, "")
      .replace(/\+/g, "-")
      .replace(/\//g, "_");
  }

  // Example usage
  async generateCodeChallengeAndVerifier(): Promise<{
    codeVerifier: string;
    codeChallenge: string;
  }> {
    const codeVerifier: string = this.generateCodeVerifier();
    const codeChallenge: string = await this.generateCodeChallenge(
      codeVerifier
    );
    return { codeVerifier, codeChallenge };
  }

  clearLogoutTimer() {
    if (this.tokenExpirationTimer) {
      clearTimeout(this.tokenExpirationTimer); // Clear the timer
      this.tokenExpirationTimer = null;
    }
  }

  logout() {
    sessionStorage.removeItem("isSeenWelcome");
    sessionStorage.removeItem("accessToken");
    sessionStorage.clear();
    this.clearLogoutTimer();
    // window.location.reload();
    // window.location.replace("/");
    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${this.redirectionUrl}`
    sessionStorage.removeItem("accessToken");

  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, "x", {
      duration: 2000, // Optional: Set duration in milliseconds
      horizontalPosition: "center", // Optional: Set horizontal position
      verticalPosition: "top", // Optional: Set vertical position
    });
  }
}
